var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.intercomExists)?_c('div',[_vm._t("default",function(){return [_c('button',{class:`button-${_vm.buttonSize} ${_vm.buttonStyle}`,on:{"click":_vm.openChatWindow}},[_vm._v("\n            "+_vm._s(_vm.buttonLabel)+"\n        ")])]},{"openChatWindow":_vm.openChatWindow})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }